import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// -----Pages-----
import { PageNotFoundComponent } from "./Layout/page-not-found/page-not-found.component";
import { HomepageComponent } from "./Layout/homepage/homepage.component";
import { ContactosComponent } from "./Pages/Informar/contactos/contactos.component";
import { SobreNosComponent } from "./Pages/Linhas/sobre-nos/sobre-nos.component";
import { PlaneadorViagensComponent } from "./Pages/Viajar/planeador-viagens/planeador-viagens.component";
import { LinhasComponent } from "./Pages/Viajar/linhas/linhas.component";
import { HorariosComponent } from './Pages/Viajar/horarios/horarios.component';
import { NoticiasComponent } from "./Pages/Linhas/noticias/noticias.component";
import { ApoioPassageiroComponent } from "./Pages/Informar/apoio-passageiro/apoio-passageiro.component";
import { FaqComponent } from "./Pages/Informar/faq/faq.component";
import { AcessibilidadeComponent } from "./Pages/Viajar/acessibilidade/acessibilidade.component";
import { ParagensComponent } from "./Pages/Viajar/paragens/paragens.component";
import { DescontosComponent } from "./Pages/Comprar/descontos/descontos.component";
import { TarifariosComponent } from "./Pages/Comprar/tarifarios/tarifarios.component";
import { ViagensOcasionaisComponent } from "./Pages/Comprar/viagens-ocasionais/viagens-ocasionais.component";
import { PontosVendaComponent } from "./Pages/Comprar/pontos-venda/pontos-venda.component";
import { DireitosPassageirosComponent } from "./Pages/Informar/direitos-passageiros/direitos-passageiros.component";
import { PoliticaCookiesComponent } from "./Pages/Informar/politica-cookies/politica-cookies.component";
import { AvisoLegalComponent } from "./Pages/Informar/aviso-legal/aviso-legal.component";
import { PoliticaPrivacidadeComponent } from "./Pages/Informar/politica-privacidade/politica-privacidade.component";
import { TresRiosComponent } from "./Pages/Linhas/tres-rios/tres-rios.component";
import { NoticiasDetalheComponent } from "./Pages/Linhas/noticias/noticias-detalhe/noticias-detalhe.component";
import { ReclamacaoDetalheComponent } from "./Pages/Informar/apoio-passageiro/reclamacao-detalhe/reclamacao-detalhe.component";
import { SearchPageComponent } from "./Layout/search-page/search-page.component";
import { Error500Component } from "./Layout/error-500/error-500.component";
import { ReservarDetalheComponent } from "./Pages/Viajar/acessibilidade/reservar-detalhe/reservar-detalhe.component";


const routes: Routes = [
  { path: '', component: HomepageComponent },
  { path: 'sobre-nos', component: SobreNosComponent },
  { path: 'tres-rios', component: TresRiosComponent },
  { path: 'planeador', component: PlaneadorViagensComponent },
  { path: 'reservas', component: AcessibilidadeComponent },
  { path: 'reservas-detalhe', component: ReservarDetalheComponent },
  { path: 'linhas', component: LinhasComponent },
  { path: 'horarios', component: HorariosComponent },
  { path: 'noticias', component: NoticiasComponent },
  { path: 'noticias-detalhe', component: NoticiasDetalheComponent },
  { path: 'paragens', component: ParagensComponent },
  { path: 'descontos', component: DescontosComponent },
  { path: 'tarifarios', component: TarifariosComponent },
  { path: 'viagens-ocasionais', component: ViagensOcasionaisComponent },
  { path: 'pontos-venda', component: PontosVendaComponent },
  { path: 'faq', component: FaqComponent },
  { path: 'apoio-passageiros', component: ApoioPassageiroComponent },
  { path: 'reclamacao-detalhe', component: ReclamacaoDetalheComponent },
  { path: 'resultados-pesquisa', component: SearchPageComponent },
  { path: 'contactos', component: ContactosComponent },
  { path: 'direitos-deveres', component: DireitosPassageirosComponent },
  { path: 'politica-cookies', component: PoliticaCookiesComponent },
  { path: 'aviso-legal', component: AvisoLegalComponent },
  { path: 'politica-privacidade', component: PoliticaPrivacidadeComponent },
  { path: '500', component: Error500Component },
  { path: '**', component: PageNotFoundComponent },
];

@NgModule({
  imports: [ RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled', onSameUrlNavigation: 'reload' }) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule { }
